import axios from 'axios';

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Could not read the selected file'));
    reader.readAsDataURL(file);
  });
}

function isBlockedS3Put(error) {
  const status = error?.response?.status;
  const message = String(error?.message || '');
  return (
    status === 403 ||
    status === 400 ||
    error?.code === 'ERR_NETWORK' ||
    /network error/i.test(message)
  );
}

/**
 * PUT a file to an S3 presigned URL. If the browser is blocked (CORS / signature),
 * return a data URL so the profile can still be saved.
 */
export async function uploadToSignedUrl(url, key, file) {
  const contentType = file.type || 'application/octet-stream';
  try {
    await axios.put(url, file, {
      headers: { 'Content-Type': contentType },
    });
    return key;
  } catch (error) {
    if (!isBlockedS3Put(error)) throw error;
    return readFileAsDataUrl(file);
  }
}
